import { render, staticRenderFns } from "./chinaumsPayStatus.vue?vue&type=template&id=224108ae&scoped=true"
import script from "./chinaumsPayStatus.vue?vue&type=script&lang=js"
export * from "./chinaumsPayStatus.vue?vue&type=script&lang=js"
import style0 from "./chinaumsPayStatus.vue?vue&type=style&index=0&id=224108ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224108ae",
  null
  
)

export default component.exports